export class Http {
    static post(uri, form) {
        return Spark.sendForm('post', uri, form)
    }

    static put(uri, form) {
        return Spark.sendForm('put', uri, form)
    }

    static patch(uri, form) {
        return Spark.sendForm('patch', uri, form)
    }

    static delete(uri, form) {
        return Spark.sendForm('delete', uri, form)
    }

    static sendForm(method, uri, form) {
        return new Promise((resolve, reject) => {
            form.startProcessing()

            axios[method](uri, JSON.parse(JSON.stringify(form.data())))
                .then(response => {
                    form.finishProcessing()

                    resolve(response.data)
                })
                .catch(errors => {
                    form.setErrors(errors.response.data.errors)

                    reject(errors.response.data)
                })
        })
    }

    static sendFormData(method, uri, form) {
        return new Promise((resolve, reject) => {
            form.startProcessing()

            let data = form.data()

            data._method = method
            data = toFormData(data)
            method = method === 'get' ? 'get' : 'post'

            axios[method](uri, data)
                .then(response => {
                    form.finishProcessing()

                    resolve(response.data)
                })
                .catch(errors => {
                    form.setErrors(errors.response.data.errors)

                    reject(errors.response.data)
                })
        })
    }
}

function toFormData(data, form, namespace) {
    let formKey

    if (typeof form === 'undefined') {
        form = new FormData()
    }

    for (let property in data) {
        if (data.hasOwnProperty(property)) {
            if (namespace) {
                formKey = namespace + '[' + property + ']'
            } else {
                formKey = property
            }

            if (data[property] === null) {
                form.append(formKey, '') // Fix FormData bug that can't handle null
            } else if (typeof data[property] === 'object' && !(data[property] instanceof File)) {
                toFormData(data[property], form, formKey)
            } else {
                // if it's a string or a File object
                form.append(formKey, data[property])
            }
        }
    }

    return form
}
